/**
 * Created by cl-macmini-51 on 03/09/18.
 */

export enum GoogleAnalyticsEvent {
  'sign_in_success' = 'signin_success',
  'sign_in_failure' = 'signin_failure',
  'signup_success' = 'signup_success',
  'signup_failure' = 'signup_failure',
  'forgot_password_click'='forgot_password_click',
  'forgot_password_success'='forgot_password_success',
  'guest_register'='guest_register',
  'forgot_password_failure'='forgot_password_failure',
  'otp_success'='otp_success',
  'otp_resend'='otp_resend',
  'otp_change_number'='otp_change_number',
  'otp_failure'='otp_failure',
  'product_share'='product_share',
  'order_listing'='order_listing',
  'order_details'='order_details',
  'location_search'='location_search',
  'driver_rate_success'='driver_rate_success',
  'order_cancel'='order_cancel',
  'location_search_success'='location_search_success',
  'add_address'='add_address',
  'edit_saved_address'='edit_saved_address',
  'remove_saved_address'='remove_saved_address',
  'banner_click'='banner_click',
  'business_category_click'='business_category_click',
  'delivery_mode_click'='delivery_mode_click',
  'product_success'='product_success',
  'product_failure'='product_failure',
  'order_rate_success' ='order_rate_success',
  'fetch_restaurant_listing'='fetch_restaurant_listing',
  'search_merchant'='search_merchant',
  'merhant_details'='merhant_details',
  'merhant_rating_list'='merhant_rating_list',
  'merhant_add_rating'='merhant_add_rating',
  'add_quantity' = 'add_quantity',
  'remove_quantity' = 'remove_quantity',
  'clear_cart'='clear_cart',
  'go_to_checkout' = 'go_to_checkout',
  'go_to_custom_checkout'='go_to_custom_checkout',
  'promo_apply_success'='promo_apply_success',
  'promo_apply_failure'='promo_apply_failure',
  'apply_loyalty_points'='apply_loyalty_points',
  'tip_apply_success'='tip_apply_success',
  'tip_remove'='tip_remove',
  'go_to_payment' = 'go_to_payment',
  'product_category_click' = 'product_category_click',
  'purchase' = 'purchase',
  'order_created_failure' = 'order_created_failure',
  'find_business' = 15,
  'choose_time_slots' = 'choose_time_slots',
  'add_to_cart' = 'add_cart',
  'search_product' = 'search_product',
  'order_detail_with_orderId' = 'order_detail_with_orderId',
  'order_detail_with_customerID' = 'order_detail_with_customerID'

}

export enum ProjectTypeEnum {
  'LOGISTICS' = 1,
  'FREELANCER',
  'FREELANCER_WITHOUT_BIDDING'
}


export enum PaymentMode {
  STRIPE = 2,
  MAMOPAY = 3,
  PAYPAL = 4,
  PAYPALV2 = 6,
  PAYPAL_COMMERCE = 7,
  TELR = 287,
  CASH = 8,
  PAY_ON_DELIVERY = 9,
  PAYFORT = 32,
  PAYTM = 64,
  RAZORPAY = 128,
  JUSPAY_SDK = 243,
  WORLDPAY   = 244,
  ELAVON     = 245,
  PAYSTACK = 256,
  BILLPLZ = 512,
  FAC = 2048,
  INNSTAPAY = 4096,
  VIVA = 2097152,
  PAYFAST = 1024,
  PAYU = 8192,
  WALLET = 16384,
  AUTHORIZE_NET = 32768,
  PAY_LATER = 65536,
  PAY_MOB = 131072,
  VISTA = 262144,
  PAYNOW = 1048576,
  STRIPE_IDEAL = 524288,
  MPAISA = 8388608,
  PAYTM_LINK = 16777216,
  // WIRE_CARD = 33554432,
  SSL_COMMERZ = 67108864,
  LIME_LIGHT = 134217728,
  TWO_CHECKOUT = 268435456,
  FAC_3D = 1073741824,
  CHECKOUT_COM = 536870912,
  PAYHERE = 4194304,
  AZUL = 2147483648,
  HYPERPAY = 4294967296,
  CREDIMAX = 33554432,
  MY_FATOORAH = 8589934592,
  THETELLER = 17179869184,
  PAYNET = 34359738368,
  TAP = 68719476736,
  CURLEC = 137438953472,
  WIPAY = 274877906944,
  PAGAR = 549755813888,
  WHOOSH = 1099511627776,
  MTN = 2199023255552,
  WECHAT = 4398046511104,
  ONEPAY = 8796093022208,
  PAGOPLUX = 17592186044416,
  MYBILLPAYMENT = 35184372088832,
  VALITOR = 140737488355328,
  TRUEVO = 562949953421312,
  BHARATPE = 281474976710656,
  PAYZEN = 1125899906842624,
  FIRSTDATA = 2251799813685248,
  BANKOPEN = 70368744177664,
  SQUARE = 4503599627370496,
  CYBERSOURCEv2 = 253,
  ETISALAT = 257,
  SUNCASH = 258,
  GOCARDLESS = 259,
  ATH = 260,
  IPAY88 = 261,
  PROXYPAY = 262,
  CYBERSOURCE = 263,
  ALFALAH = 264,
  CULQI = 265,
  NMI = 266,
  FLUTTERWAVE = 267,
  MPESA = 268,
  ADYEN = 269,
  PAYMARK = 271,
  HYPUR = 270,
  PAYTMV3 = 272,
  PIXELPAY = 273,
  DOKU = 274,
  PEACH = 275,
  PEACH_V2 = 295,
  PAGUELOFACIL = 276,
  NOQOODY = 277,
  URWAY = 278,
  GTBANK = 279,
  CXPAY = 280,
  VPOS = 281,
  VUKA = 282,
  PAYKU = 283,
  REVOLUT = 284,
  BAMBORA = 285,
  PAYWAYONE = 286,
  EWAY = 288,
  PLACETOPAY = 297,
  CEVNN = 299,
  PAYMAYA = 301,
  UNIPAY = 302,
  BENEFIT = 298,
  GOOGLEPAY = 304,
  CMI = 305,
  OPENPAY = 307,
  CUSTOMPG = 303,
  PAYMENTEZ = 311,
  PAYGATE = 3001,
  SBM = 702,
  QPAY = 704,
  MERCADO = 729,
  KANOO = 3002,
  CUSTOM_PG_START = 600000000000000,
  CUSTOM_PG_END = 999999999999999,
  BILLPLZV2 = 3003,
  WOMPI = 3013,
  PAYZENV2 = 5001,
  PAYFORTV2 = 5002,
  REDSYS = 5005,
  KEYPAY = 7000,
  HALYKBANK = 7001,
  QUADPAY = 5009,
  PAYWAY = 5010,
  ORANGE_PAY = 5012,
  APCOPAY = 5019,
  SPOTII = 5020,
  PAYTABS = 5021,
  WEBPAY = 7002,
  STRIPE_STANDARD_CONNECT = 5022,
  RAZORPAY_V2 = 5025,
  POWERTRANZ = 5026,
  AEROPAY = 5027,
  TAPPAY = 5028,
  PAYTM_UPI = 5007,
  RAZORPAY_UPI = 5006,
  CONVENIENCE_PAY = 6561,
  JAZZ_CASH = 402,
  PAYTEN = 2187,
  PAYMOB_V2 = 59049,
  OZOW = 177147,
  ETHIO_TELECOM = 19683,
  CAYMAN = 63,
}

export const PAYMENT_METHODS = {
  '244' : 'WORLDPAY',
  '245' : 'ELAVON',
  '253' : 'Cybersourcev2',
  '257': 'Etisalat',
  '259': 'GoCardless',
  '261': 'Ipay88',
  '263' : 'Cybersource',
  '265' : 'Culqi',
  '266' : 'Nmi',
  '267' : 'Flutterwave',
  '269' : 'Adyen',
  '270' : 'Hypur',
  '272' : 'PaytmV3',
  '273' : 'Pixelpay',
  '274' : 'Doku',
  '275' : 'Peach',
  '276' : 'Paguelofacil',
  '277' : 'Noqoody',
  '279' : 'Gtbank',
  '280' : 'Cxpay',
  '282' : 'Vuka',
  '284' : 'Revolut',
  '285' : 'Bambora',
  '286' : 'Paywayone',
  '288' : 'Eway',
  '295' : 'Peach V2(Embedded Checkout)',
  '297' : 'Placetopay',
  '298': 'Benefit',
  '299' : 'Cevnn',
  '301' : 'Paymaya',
  '305': 'CMI',
  '307' : 'Openpay',
  '311' : 'Paymentez',
  '304' : 'Googlepay',
  '702' : 'SBM',
  '1024' : 'Payfast',
  '3001' : 'Paygate',
  '3002' : 'Kanoo',
  '2097152': 'Viva',
  '67108864': 'SslCommerz',
  '1073741824' : 'Fac3d',
  '4294967296': 'Hyperpay',
  '68719476736': 'Tap',
  '274877906944': 'Wipay',
  '549755813888': 'Pagar.me',
  '1099511627776': 'Whoosh',
  '2199023255552': 'MTN',
  '562949953421312': 'Truevo',
  '1125899906842624': 'Payzen',
  '2251799813685248' : 'Fristdata',
  '4503599627370496': 'SquareUp',
  '59049': 'Paymob Checkout',
  '19683': 'Ethio Telecom',
}

export const PaymentMethodsNewFlow = [
  PaymentMode.TAP, PaymentMode.BENEFIT, PaymentMode.ETISALAT, PaymentMode.IPAY88, PaymentMode.PAYZEN, PaymentMode.CMI, PaymentMode.VIVA, PaymentMode.HYPERPAY, PaymentMode.WIPAY, PaymentMode.PAGAR, PaymentMode.EWAY, PaymentMode.OPENPAY, PaymentMode.PAYGATE, PaymentMode.SBM, PaymentMode.WHOOSH, PaymentMode.MTN, PaymentMode.TRUEVO, PaymentMode.SQUARE, PaymentMode.GOCARDLESS, PaymentMode.CEVNN, PaymentMode.FLUTTERWAVE, PaymentMode.VUKA, PaymentMode.CXPAY, PaymentMode.PAYMAYA, PaymentMode.GTBANK, PaymentMode.REVOLUT, PaymentMode.PAYMENTEZ, PaymentMode.PEACH, PaymentMode.CYBERSOURCE, PaymentMode.KANOO, PaymentMode.BAMBORA, PaymentMode.PAYWAYONE, PaymentMode.PLACETOPAY, PaymentMode.NOQOODY, PaymentMode.NMI, PaymentMode.DOKU, PaymentMode.CULQI, PaymentMode.ADYEN, PaymentMode.PAGUELOFACIL, PaymentMode.HYPUR, PaymentMode.PAYTMV3, PaymentMode.GOOGLEPAY,PaymentMode.PAYFAST, PaymentMode.FIRSTDATA, PaymentMode.PIXELPAY, PaymentMode.SSL_COMMERZ, PaymentMode.FAC_3D, PaymentMode.AZUL, PaymentMode.MY_FATOORAH, PaymentMode.PAGOPLUX, PaymentMode.PROXYPAY, PaymentMode.VPOS,
  PaymentMode.ATH, PaymentMode.CHECKOUT_COM, PaymentMode.CREDIMAX, PaymentMode.PAYHERE, PaymentMode.SUNCASH, PaymentMode.MYBILLPAYMENT, PaymentMode.BANKOPEN, PaymentMode.CURLEC, PaymentMode.PAYKU, PaymentMode.PAYNET, PaymentMode.THETELLER, PaymentMode.BILLPLZV2, PaymentMode.STRIPE_IDEAL, PaymentMode.ALFALAH, PaymentMode.MPESA, PaymentMode.PAYU, PaymentMode.PAY_MOB, PaymentMode.URWAY, PaymentMode.VALITOR, PaymentMode.UNIPAY, PaymentMode.WOMPI, PaymentMode.PAYZENV2, PaymentMode.KEYPAY, PaymentMode.QPAY, PaymentMode.HALYKBANK, PaymentMode.APCOPAY, PaymentMode.SPOTII, PaymentMode.PAYTABS, PaymentMode.WEBPAY,PaymentMode.STRIPE_STANDARD_CONNECT,PaymentMode.POWERTRANZ,PaymentMode.AEROPAY,PaymentMode.TAPPAY,PaymentMode.JAZZ_CASH, PaymentMode.MAMOPAY, PaymentMode.CYBERSOURCEv2, PaymentMode.JUSPAY_SDK, PaymentMode.MERCADO, PaymentMode.PAYTEN, PaymentMode.WORLDPAY, PaymentMode.PEACH_V2, PaymentMode.CONVENIENCE_PAY, PaymentMode.PAYMOB_V2, PaymentMode.OZOW, PaymentMode.ETHIO_TELECOM, PaymentMode.PAYPAL_COMMERCE, PaymentMode.CAYMAN, PaymentMode.ELAVON
]

export const DefaultPGSet = new Set([
  PaymentMode.REDSYS,
  PaymentMode.PAYFORTV2,
  PaymentMode.QUADPAY,
  PaymentMode.PAYWAY,
  PaymentMode.ORANGE_PAY,
])


export enum CREATE_TASK_TYPE {
  FOOD = 1,
  CUSTOM_ORDER = 2,
  LAUNDARY = 3,
  FREELANCER = 4,
  CREATE_CHARGE=7,
  QUOTATION =9,
  LAUNDARY_CUSTOM_ORDER= 9,
  REWARD=10
  };

export enum PaymentFor {
  REWARDS = 5,
  REPAYMENT = 4,
  GIFT_CARD = 3,
  WALLET = 2,
  VENDOR_SUBSCRIPTION = 1,
  CREATE_TASK = 0,
  DEBT_AMOUNT = 6,
  CUSTOMER_SUBSCRIPTION_AMOUNT = 11,
  CUSTOM_ORDER =10
}
export enum PaymentByUsing {
 USING_FAC=2
}

export enum OnboardingBusinessType {
  LAUNDRY = 805,
  CAR_RENTAL = 902,
  RENTALS = 9,
  FOOD = 8,
  GROCERIES = 802,
  CANNABIS = 801,
  FOOD_CATERING = 804,
  PHARMACY = 803,
  BEAUTY = 7,
  HOME_SERVICES = 701,
  FREELANCER = 12
}

export enum WalletStatus {
  ADD = 1,
  DEDUCTION = 2,
  REFUND = 3,
  CREDIT = 4,
  FAIL = 5,
  GIFT_CARD_PURCHASE = 6,
  GIFT_CARD_REDEEM = 7,
  ADMIN_DEDUCTION = 8,
  REWARD_CASHBACK = 9,
  REWARD_BUY = 10,
  DEBT_PAID = 11,
  CUSTOMER_SUBSCRIPTION = 12,
  PAYMENT_LINK = 13,
  P2P_SENT = 14,
  P2P_RECEIVED = 15
}


export enum PromotionOn {
  SUBTOTAL = 0,
  DELIVERY_CHARGE = 1,
  PRODUCT = 2
}


export enum PromoMode {
  PUBLIC = 0,
  HIDDEN,
  AUTO_APPLY,
}

export enum GiftCardType {
  SELF_REEDEM = 1,
  RECEIVED = 2,
  SENT = 3,
  OTHER_REEDEM = 4,
}

export enum CheckoutTemplateType {
  NORMAL_ORDER = 0,
  CUSTOM_ORDER = 1,
}

export enum TransactionStatusEnum {
  ORDER_COMPLETE = 1,
  TRANSACTION_COMPLETE,
  INIT,
  PAYMENT_FAILED_REFUNDED,
  TRANSACTION_INCOMPLETE,
  REFUNDED,
  TRANSACTION_FAILED,
  PARTIAL_PAYMENT,
  PARTIALLY_REFUNDED,
  PAYMENT_HOLD,
  PAYMENT_RELEASED
}

export enum BusinessType {
  PRODUCT_MARKETPLACE = 1,
  SERVICE_MARKETPLACE = 2
}

export enum TaskType {
  PICKUP_AND_DELIVERY = 1,
  APPOINTMENT = 2,
  SERVICE_AS_PRODUCT = 3
}

export enum TimeFormat {
  TWELVE_HOURS = 1,
  TWENTY_FOUR_HOURS = 2
}
export enum DeliveryMethod {
  SELF_PICKUP = 4,
  HOME_DELIVERY = 2
}
export enum AmountService {
  Price = 1,
  ConvertToSec=0
}
export enum PageType {
  THANKYOU = 1,
  ERROR = 2
}
// export enum AddonType {
//   NETCORE = 109
// }
export enum DAY {
  SUNDAY = 0,
  MONDAY,
  TUESDAY,
  WEDNESDAY,
  THURSDAY,
  FRIDAY,
  SATURDAY
}

export enum RecurringOrderStatus {
  PENDING = 0,
  ACCEPTED = 1,
  REJECTED = 2
};

export enum LoginBy {
  LOCAL_STORAGE = 1,
  QUERY_PARAMS = 2
}
export enum LocationType {
  HOME = 0,
  WORK = 1,
  OTHERS=2
}


export enum FreelancerAddress {
  PROJECT_ADDRESS = 1,
  PICKUP_ADDRESS
}

export enum Inspectlet {
  JINI = 865942142,
  DIETBUDDY = 1287903440
}

export enum MarketplaceUserId {
  JINI = 166876,
  DIETBUDDY = 175522
}

export enum MapType {
  FLIGHTMAP = 0,
  GOOGLEMAP = 2
}

export enum exportPageEnum  {
  HOME  = '/',
  LIST = '/list',
  SEARCH = '/search',
  CHECKOUT =  '/checkout',
  NAVIGATION = '/mobile-navigation',
  WALLET = '/wallet',
  ORDER = '/orders',
  TATANEU = '/tataneu'
}
export enum merchantSignupType {
  MULTIPLE_MERCHANTS = 0,
  SINGLE_STORE_SINGLE_ADMIN = 1,
  SINGLE_STORE_MULTIPLE_MERCHANTS = 2
}

export enum tataUserType {
  new = "new",
  existing = "existing",
}

export enum tataKeys { 
  loyalCustomer = "Y",
  redirectUrl = "https://tatadigital.com", //test url
  // redirectUrl = "https://order.qmin.co.in",  //prod url
  consentType = "Explicit"
}
export enum WalletSourceType {
  YELO             = 1,
  INTERNAL_PRODUCT = 2
}
export enum deliverymodes{
  home_delivery=1,
  self_pickup=2,
  pick_and_drop=8
}

export enum registerMethod {
  EMAIL = 0,
  PHONE = 1,
  EMAIL_AND_PHONE = 2
};

export enum RECURRING_TYPE {
  Everyday = 0,
  Weekdays = 1,
  Weekends = 2,
  Fortnight = 3,
  Monthly = 4
}

export const RECURRING = {
  CYCLE_TYPE : {
    Everyday : 0,
    Fortnight : 15,
    Monthly : 30
  },
  DAYS : {
    Everyday : 7,
    Fortnight : 14,
    Monthly : 30
  }
}

export enum PaymentProcessType {
    POST_PAYMENT        = 1,
    PRE_PAYMENT         = 0,
    WEBHOOK_PAYMENT     = 2
}
export enum PaymentDiscountType {
    FIXED      = 0,
    PERCENTAGE = 1
}
export enum PaymentDiscountCriteria {
    TOTAL_ORDER_VALUE = 0,
    CART_VALUE        = 1
}

export enum SocketEvent {
  FEEDBACK_EVENT = 'feedback_event'
}

export enum FeedbackEventType {
  GROWTH_SCORE = 'growth_score'
}